//@flow
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CarouselStatements from 'components/atoms/horizontalCarouselStatements';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

type DataPropType = {
  name: string,
  roleShortDescription: string,
  roleLongDescription: string,
  jobLongDescription: string,
  department: string,
  verticalName: string,
  city: string,
  country: string,
  business: string,
};

type Props = {
  data: Object<DataPropType>,
  roleName?: string,
};

export const AboutRole = (props: Props) => {
  const { roleName } = props;
  const {
    name,
    roleShortDescription,
    roleLongDescription,
    jobLongDescription,
    department,
    business,
    city,
    country,
  } = props.data;

  const { height } = useViewport();

  const carousal_data = [
    {
      title: 'ROLE',
      classname: 'card1',
      data: roleLongDescription,
    },
    {
      title: 'CARD 2',
      classname: 'card2',
      data: jobLongDescription,
    },
  ];

  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const lengthOfSliders =
    carousal_data && carousal_data
      ? carousal_data.length < 2
        ? 1
        : carousal_data.length
      : '';

  return (
    <div className={'about-role-body section-container'} style={{ height }}>
      <div className={'inner-section-body'}>
        <div className="left-section">
          <CarouselStatements
            containerClassName={'statements'}
            headingClassName={'section-heading'}
            subHeadingClassName={'sub-heading'}
            descriptionClassName={'paragraph'}
            heading={'About The Role'}
            subHeading={name}
            description={roleShortDescription}
          />
          <div className={'button-info-container'}>
            <Row>
              <Col md={{ span: 6 }}>
                <h4>Department</h4>
                <p>{department}</p>
              </Col>
              <Col md={{ span: 6 }}>
                <h4>Business</h4>
                <p>{business}</p>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 6 }}>
                <h4>Location</h4>
                <p>{city}</p>
              </Col>
            </Row>
          </div>
        </div>
        <div className={'role-carousal-container'}>
          <div className="slider">
            {carousal_data ? (
              <HorizontalCarousel
                data={carousal_data}
                type={'jobAboutRole'}
                cssFor={'job-about-role'}
                getActiveSlide={e => {
                  setActiveSlide(e);
                }}
                handleSliderRef={handleSliderRef}
              />
            ) : null}
          </div>
        </div>
      </div>
      <div className="section-footer">
        <PaginationControl
          className={'section-footer-item'}
          theme={'light-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={lengthOfSliders}
          onNextClick={next}
          onPreviousClick={previous}
          key={'17'}
        />
      </div>
    </div>
  );
};
